const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const sequences = [
  {
    root: '.aa-section--hero',
    stages: [
      { selector: ':scope > .aa-media', role: 'media' },
      { selector: ':scope > .aa-layout > .aa-text', role: 'context', delay: 70, stagger: 55 },
      { selector: ':scope > .aa-layout > .aa-link-wrap', role: 'action', delay: 190 },
    ],
  },
  {
    root: '.aa-section--intro',
    stages: [
      { selector: ':scope > .aa-layout > .aa-text', role: 'context', stagger: 55 },
      { selector: ':scope > .aa-layout > .aa-link-wrap', role: 'action', delay: 170 },
    ],
  },
  {
    root: '.aa-section--trending',
    stages: [
      { selector: ':scope > .aa-layout:first-of-type', role: 'context' },
      { selector: '.aa-product', role: 'peer', delay: 70, stagger: 55, staggerLimit: 5 },
      { selector: ':scope > .aa-trending__actions', role: 'action', delay: 190 },
    ],
  },
  {
    root: '.aa-atlas',
    stages: [
      { selector: '.aa-atlas__header', role: 'context' },
      { selector: '.aa-atlas__note', role: 'peer', delay: 70, stagger: 70, staggerLimit: 5 },
      { selector: '.aa-atlas__control', role: 'action', delay: 210 },
    ],
  },
  {
    root: '.aa-section--feature',
    stages: [
      { selector: '.aa-campaign__media', role: 'media' },
      { selector: '.aa-campaign__content > .aa-text', role: 'context', delay: 65, stagger: 50 },
      { selector: '.aa-campaign__content > .aa-link-wrap', role: 'action', delay: 210 },
    ],
  },
  {
    root: '.aa-section--founder',
    stages: [
      { selector: '.aa-overlap', role: 'media' },
      { selector: '.aa-layout > .aa-layout > .aa-text', role: 'context', delay: 65, stagger: 45, staggerLimit: 4 },
      { selector: '.aa-layout > .aa-layout > .aa-link-wrap', role: 'action', delay: 220 },
    ],
  },
  {
    root: '.aa-section--curated',
    stages: [
      { selector: ':scope > .aa-layout:first-of-type > .aa-text', role: 'context', stagger: 50 },
      { selector: ':scope > .aa-layout:first-of-type > .aa-link-wrap', role: 'action', delay: 150 },
      { selector: ':scope > .aa-layout:last-of-type > .aa-media', role: 'media', delay: 70 },
      { selector: ':scope > .aa-layout:last-of-type .aa-product', role: 'peer', delay: 120, stagger: 55 },
    ],
  },
  {
    root: '.al-anfar-pdp-hero:not(.al-anfar-pdp-hero--empty)',
    stages: [
      { selector: '.al-anfar-pdp-hero__media', role: 'media' },
      { selector: ':scope > h1', role: 'context', delay: 75 },
    ],
  },
  {
    root: '.product-information',
    stages: [
      { selector: '.product-information__media', role: 'media' },
      { selector: '.product-details', role: 'context', delay: 70 },
    ],
  },
  {
    root: '.aa-mobile-campaign',
    stages: [{ selector: '.aa-mobile-campaign__frame', role: 'media' }],
  },
  {
    root: '.aa-pdp-notes-intro',
    stages: [{ selector: '.aa-pdp-notes-intro__inner', role: 'context' }],
  },
  {
    root: '.aa-notes-visual',
    stages: [{ selector: '.aa-notes-visual__frame', role: 'media' }],
  },
  {
    root: '.al-anfar-product-image-pair',
    stages: [{ selector: '.al-anfar-product-image-pair__image', role: 'peer', stagger: 70 }],
  },
  {
    root: '.aa-editorial-split',
    stages: [
      { selector: '.aa-editorial-split__media', role: 'media' },
      { selector: '.aa-editorial-split__content', role: 'context', delay: 70 },
    ],
  },
  {
    root: '.aa-collection-hero',
    stages: [
      { selector: '.aa-collection-hero__media', role: 'media' },
      { selector: '.aa-collection-hero__content', role: 'context', delay: 70 },
    ],
  },
  {
    root: '.aa-discovery-rail',
    stages: [{ selector: '.aa-discovery-rail__inner', role: 'support' }],
  },
  {
    root: '.aa-collection-results',
    stages: [
      { selector: '.collection-wrapper > :first-child', role: 'context' },
      { selector: '#ResultsList', role: 'support', delay: 70 },
    ],
  },
  {
    root: '.aa-page-hero',
    stages: [{ selector: '.aa-page-hero__inner', role: 'context' }],
  },
  {
    root: '.aa-heritage-hero',
    stages: [
      { selector: '.aa-heritage-hero__media', role: 'media' },
      { selector: '.aa-heritage-hero__content', role: 'context', delay: 80 },
      { selector: '.aa-heritage-hero__cue', role: 'action', delay: 220 },
    ],
  },
  {
    root: '.aa-heritage-origin',
    stages: [
      { selector: '.aa-heritage-origin__object', role: 'media' },
      { selector: '.aa-heritage-origin__lead', role: 'context', delay: 70 },
      { selector: '.aa-heritage-years li', role: 'peer', delay: 150, stagger: 65 },
    ],
  },
  {
    root: '.aa-heritage-founder',
    stages: [
      { selector: '.aa-heritage-founder__portrait', role: 'media' },
      { selector: '.aa-heritage-founder__copy', role: 'context', delay: 75 },
    ],
  },
  {
    root: '.aa-heritage-collections',
    stages: [
      { selector: '.aa-heritage-collections__header', role: 'context' },
      { selector: '.aa-heritage-montage__item', role: 'peer', delay: 90, stagger: 55, staggerLimit: 5 },
    ],
  },
  {
    root: '.aa-heritage-closing',
    stages: [{ selector: ':scope > *', role: 'context', stagger: 60 }],
  },
  {
    root: '.aa-collections-index',
    stages: [
      { selector: '.aa-collections-index__chapter', role: 'peer', stagger: 65, staggerLimit: 6 },
      { selector: '.aa-collections-index__all', role: 'action', delay: 220 },
    ],
  },
  {
    root: '.aa-page-section',
    stages: [{ selector: ':scope > .aa-page-section__inner', role: 'chapter' }],
  },
  {
    root: '.aa-contact-hero',
    stages: [{ selector: '.aa-contact-hero__inner', role: 'context' }],
  },
  {
    root: '.aa-contact-section',
    stages: [
      { selector: '.aa-contact-visual', role: 'media' },
      { selector: '.aa-contact-form-card', role: 'context', delay: 70 },
      { selector: '.aa-contact-details', role: 'support', delay: 145 },
    ],
  },
  {
    root: '.product-recommendations',
    stages: [
      { selector: 'h3', role: 'context' },
      { selector: '.resource-list', role: 'support', delay: 70 },
    ],
  },
];

let observer;

const rootsWithin = (scope, selector) => {
  const roots = [];
  if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
  roots.push(...scope.querySelectorAll(selector));
  return roots;
};

const setSequenceState = (root, state) => {
  root.querySelectorAll('[data-aa-motion-owner]').forEach((element) => {
    if (element.dataset.aaMotionOwner === root.dataset.aaMotionSequence) {
      element.dataset.aaMotionState = state;
    }
  });
};

const revealSequence = (root) => {
  root.dataset.aaMotionEntered = 'true';
  setSequenceState(root, 'visible');
  if (root.dataset.aaMotionReplay !== 'true') observer?.unobserve(root);
};

const resetSequence = (root) => {
  if (
    reducedMotion.matches ||
    root.dataset.aaMotionReplay !== 'true' ||
    root.dataset.aaMotionEntered !== 'true'
  ) return;
  root.dataset.aaMotionEntered = 'false';
  setSequenceState(root, 'pending');
};

const createObserver = () => {
  if (observer || reducedMotion.matches || !('IntersectionObserver' in window)) return;

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealSequence(entry.target);
        } else if (entry.intersectionRatio === 0) {
          resetSequence(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
  );
};

const prepareSequence = (root, definition, sequenceIndex) => {
  if (root.dataset.aaMotionSequence) return;

  const owner = `sequence-${sequenceIndex}-${Math.random().toString(36).slice(2, 8)}`;
  root.dataset.aaMotionSequence = owner;
  root.dataset.aaMotionReplay = definition.replay ? 'true' : 'false';

  definition.stages.forEach((stage) => {
    root.querySelectorAll(stage.selector).forEach((element, index) => {
      if (element.dataset.aaMotion) return;

      const staggerIndex = Math.min(index, stage.staggerLimit ?? index);
      const delay = (stage.delay || 0) + (stage.stagger || 0) * staggerIndex;

      element.dataset.aaMotion = stage.role;
      element.dataset.aaMotionOwner = owner;
      element.dataset.aaMotionState = reducedMotion.matches ? 'visible' : 'pending';
      if (delay) element.style.setProperty('--aa-motion-delay', `${delay}ms`);
    });
  });

  if (!root.querySelector(`[data-aa-motion-owner='${owner}']`)) {
    delete root.dataset.aaMotionSequence;
    return;
  }

  if (reducedMotion.matches || !('IntersectionObserver' in window)) {
    revealSequence(root);
    return;
  }

  createObserver();
  requestAnimationFrame(() => observer.observe(root));
};

const prepareMotion = (scope = document) => {
  sequences.forEach((definition, sequenceIndex) => {
    rootsWithin(scope, definition.root).forEach((root) => prepareSequence(root, definition, sequenceIndex));
  });

  document.documentElement.classList.add('aa-motion-ready');
};

const revealAll = () => {
  document.querySelectorAll('[data-aa-motion]').forEach((element) => {
    element.dataset.aaMotionState = 'visible';
  });
};

reducedMotion.addEventListener?.('change', (event) => {
  if (event.matches) revealAll();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => prepareMotion(), { once: true });
} else {
  prepareMotion();
}

document.addEventListener('shopify:section:load', (event) => prepareMotion(event.target));
